import { Rating } from 'react-simple-star-rating';

const RatingAndWishlist = (props) => {
    const { item, rating, onWishlistToggle, isWishlisted } = props;
    const wishlistActive = Boolean(isWishlisted ?? item?.wishStatus);

    return (
        <div className="product_content_wepper mt-0">
            <div className="py-lg-2 py-1 d-flex justify-content-between align-items-center" style={{ paddingRight: '5px' }}>
                <div className="product-item">
                    <div className="product-rating d-flex align-items-center">
                        <Rating
                            initialValue={rating}
                            readonly
                            size={20}
                            label={`Rating: ${rating}`}
                            fractions={2}
                        />
                    </div>
                </div>
                <div className="wishlist_icon">
                    <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="20"
                        height="20"
                        role="button"
                        aria-label={wishlistActive ? "Remove from wishlist" : "Add to wishlist"}
                        style={{ cursor: "pointer" }}
                        onClick={() => onWishlistToggle(item)}
                    >
                        <path
                            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"
                            fill={wishlistActive ? "#f54b55" : "none"}
                            stroke={wishlistActive ? "#f54b55" : "#ffffff"}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                        />
                    </svg>
                </div>
            </div>
        </div>
    )
}

export default RatingAndWishlist;
